import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import EducacaoService from '../../../../services/contasEducacao';
import { Link } from 'react-router-dom';
import Exportar from '../../../shared/export'



const FormBusca = (props) => {
    const [fonte, setFonte] = useState("");
    const [palavra, setPalavra] = useState("");
    const [credor, setCredor] = useState("");
    const [dataIn, setDataIn] = useState("");
    const [dataFt, setDataFt] = useState("");



    const busca = async (query) => {
        if (query == "") {
            await props.fetchDespesas()
            setDataIn("")
            setFonte("")
            setDataFt("")
            setPalavra("")
            setCredor("")
        } else {
            var response = await EducacaoService.buscarDespesas(query)
            if (response.data.length >= 1) {
                props.setDespesas(response.data)
                props.setVazio(false)
                setDataIn("")
                setFonte("")
                setDataFt("")
                setPalavra("")
                setCredor("")
            } else {
                props.setVazio(true)
                setDataIn("")
                setFonte("")
                setDataFt("")
                setPalavra("")
                setCredor("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (dataIn) prepQuery = prepQuery + `&dataIn=${dataIn}`;
        if (dataFt) prepQuery = prepQuery + `&dataFt=${dataFt}`;
        if (fonte) prepQuery = prepQuery + `&fonte=${encodeURI(fonte)}`;
        if (palavra) prepQuery = prepQuery + `&palavra=${encodeURI(palavra)}`;
        if (credor) prepQuery = prepQuery + `&credor=${encodeURI(credor)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Fonte">
                                <FloatingLabel
                                    label="Fonte"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="fonte"
                                        value={fonte}
                                        onChange={e => setFonte(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Fonte">
                                <FloatingLabel
                                    label="Palavra-chave"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="palavra"
                                        value={palavra}
                                        onChange={e => setPalavra(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="dataInicial">
                                <FloatingLabel
                                    label="Data Inicial"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataIn"
                                        value={dataIn}
                                        onChange={e => setDataIn(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="dataFinal">
                                <FloatingLabel
                                    label="Data Final"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataFt"
                                        value={dataFt}
                                        onChange={e => setDataFt(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Fonte">
                                <FloatingLabel
                                    label="Credor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="credor"
                                        value={credor}
                                        onChange={e => setCredor(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/educacao'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <br/>
                    <Row xs={1}>
                        <Col xs={12}>
                            <Exportar data={props.despesas} nome={"DespesasEducacao"} />
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment >
    )
}

export default FormBusca